<template>
  <section class="lm-image" :style="{
    height: height
  }" :class="{
    'is_shadow': shadow
  }" @click="$emit('click')">
    <section class="lm-image_content">
      <img ref="content" :class="['is_block', {
        'is_scale': scale
      }]" :style="position" :src="src" />
    </section>
    <section class="lm-image_text">
      <div class="lm-image_title">{{ title }}</div>
      <div class="lm-image_intro">{{ description }}</div>
    </section>
    <div class="title-cen"><slot name="title"></slot></div>
  </section>
</template>

<style scoped lang="scss">
@import '@/assets/styles/variable.scss';

.lm-image {
  position: relative;
  overflow: hidden;
  &.is_shadow {
    box-shadow: $shallowShadow;
  }
  &:hover {
    &.is_shadow {
      box-shadow: $hoverShadow;
    }
    img.is_scale {
      cursor: pointer;
      transform: scale(1.06);
    }
  }
  &_content {
    background-color: rgb(231, 231, 231);
    img {
      width: 100%;
      transition: all $transitionDuration ease;
    }
  }
  &_text {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    padding-right: 28px;
    padding-left: 28px;
    color: #fff;
  }
  &_title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; 
    padding-bottom: 5.981px;
    font-size: 17.9444px;
  }
  &_intro {
    padding-bottom: 30px;
    font-size: 20.1875px;
  }
  .title-cen {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: #fff;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 64px;
    font-weight: 700;
  }
}
</style>

<script>
export default {
  props: {
    src: {
      type: String,
      require: true
    },
    title: {
      type: String,
      require: true
    },
    description: {
      type: String,
      require: true
    },
    height: {
      type: String,
      default: 'auto'
    },
    scale: {
      type: Boolean,
      default: true
    },
    shadow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    position() {
      if(this.height === 'auto') {
        return {}
      } else {
        return {
          position: 'relative',
        }
      }
    }
  },
  // created() {
  //   this.$nextTick(_ => {
  //       console.log('ref', _, getComputedStyle(this.$refs.content).height)
  //   })
  // }
}
</script>
